import JiaoBiao from "@/components/OrderList/JiaoBiao.vue";
import { miceService } from "@/service/miceService.js";
import { baseUrl } from '@/service/baseUrl.js'
import mealSYT from '@/components/Meal/mealSYT.js'
import {
	SmartStorage
} from 'smart-core-util'
import { setCookie,getCookie,getAllCookies } from 'tiny-cookie'
import {
    mapGetters,
    mapMutations
} from 'vuex'
export default {
    name: "Item5Detail",
    components: {
        JiaoBiao
    },
    props: ["mealList"],
    mixins: [mealSYT],
    computed: {
        ...mapGetters([
            'event',
            'orderDetail',
            'memsg',
            'shop',
            'currentPosition',
            'cityAddress',
            'address'
        ])
    },
    created: function() {
    },
    mounted() {
        
        if(this.shop.fullName) {
            this.dochangeShop()
        }
    },
    methods: {
        ...mapMutations([
            'ORDER_DETAIL',
            'XMS_PAY_RESULT',
            'FRESH_LIST',
            'EXPENSE_ID',
            'ADDRESS',
            'SHOP',
            'FRESH_SHOP'
        ]),
        show(i) {
            var icon = document.getElementsByClassName(`btn-more${i}`)[0];
            icon.style.display = "inline-block";
        },
        // 隐藏 remove-icon
        hide(i) {
            var icon = document.getElementsByClassName(`btn-more${i}`)[0];
            icon.style.display = "none";
        },
        async handleClick(btn, item) {
            if (btn.forbidden) {
                this.toast(btn.msg);
                return;
            }
            this['EXPENSE_ID'](null);
            this['ORDER_DETAIL'](item);
            this.setXmsPayResultValue(item)
            if (item.expenseId) {
                this['EXPENSE_ID'](item.expenseId);
            }
            let buttonType = btn.processor;
            switch (buttonType) {
                case 'changeShop':
                    this.changeShop(item)
                    break
                //商宴通选择餐厅
                case 'selectShop':
                    this.selectSYT(item)
                    break;
                //编辑
                case "edit":
                    item.edit = true;
                    this['ORDER_DETAIL'](item);
                    this.$router.push({
                        path: "/addMealDemand"
                    });
                    break;
                    //删除
                case "remove":
                    this.$refs.remove.openPop();
                    break;
                    //去结账
                case "toGoPay": //继续支付
                case "toPay":
                    // this.uploadInvoice(item);
                    await this.execute(item)
                    this.toPay()
                    break;
                    //上传发票
                case "uploadInvoice":
                    this.uploadInvoice(item);
                    break;
                    //支付进程 
                case "payProcess":
                    this.$router.push({ path: '/alipayResult'}) 
                    break;
                    //去付款
                case "openAlipay":
                    this.openAlipay(item);
                    break;
                    //查看详情
                case "viewDetails":
                    this.$router.push({
                        path: "/mealOrderDetail"
                    });
                    break;
                    //取消
                case "cancelOrder":
                    this.$refs.cancel.openPop();
                    break;
                    //确认费用
                case "confirmExpense":
                    this.$router.push({
                        path: "/orderSettle",
                        query: {
                            confirmExpense: true
                        }
                    });
                    break;
                    // 更新文件
                case "updateFile":
                    this.$router.push({
                        path: "/updateFile",
                        query: {
                            itemType: 5
                        }
                    });
                    break;
                    //饿了么退款
                case "refund":
                    this.$refs.refund.openPop();
                    break;
            }
        },
        execute(item) {
            let params = {
                NodeCode:"Meal_CheckCanOrder",
                ContextDataKeys:{
                    ProposalId: item.proposalId,
                    ItemId: item.itemId
                }
            }
            return new Promise((resolve, reject) => {
                miceService.execute(params).then(res => {
                    if (res && res.success) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        remove() {
            var params = {
                itemId: this.orderDetail.itemId,
                isdelete: true
            }
            miceService.deleteMealItem(params).then(res => {
                if (res && res.success) {
                    this['FRESH_LIST'](true)
                }
            })
        },
        toPay() {
            this.$router.push({
                path: "/orderSettle"
            });
        },
        uploadInvoice(item) {
            let extOrderData = JSON.parse(item.extOrderData || "{}").eleOrderInfo || {};
            if(extOrderData.employeeFee > 10) {
                this.$refs.uploadInvoice.openPop();
            } else {
                this.$router.push({
                    path: "/uploadInvoice"
                });
            }
        },
        openAlipay(item) {
            let voucherInput = {
                shopId: item.itsItemData.shopId,
                shopName: item.itsItemData.shopName,
                expenseId: item.expenseId,
                proposalId: item.proposalId,
                settleAmount: item.originAmount,
                specificAmount: item.specificAmount,
                qty: item.qty1
            };
            this.$emit('open', voucherInput)
        },
        cancelOrder() {
            let item = this.orderDetail
            let temp = ((item.itsItemData || { payProfile:'' }).payProfile || {PayModes: []});
            let payMode = typeof(temp.PayModes) == 'object' ? temp.PayModes[0] : temp.PayModes;
            if(payMode==9 && item.extOrderId) {
                var formdata = new FormData();
                formdata.append("orderId",item.extOrderId);
                miceService.cancelorderSYT(formdata).then(res => {
                    this.cancelMeal(item)
                })
            } else {
                this.cancelMeal(item)
            }
        },
        cancelMeal(item) {
            var params = {
                itemId: item.itemId
            }
            miceService.cancelMealItem(params).then(res => {
                if (res && res.success) {
                    this['FRESH_LIST'](true)
                }
            })
        },
        refund() {
            let params = {
                itemId: this.orderDetail.itemId
            }
            miceService.eleRefund(params).then(res => {
                if (res && res.success) {
                    this['FRESH_LIST'](true)
                }
            })
        },
        //更换餐厅
        async changeShop(item) {
            item.edit = false
            this['ORDER_DETAIL'](item);
                if(['novartis'].includes(this.event.tenant_code)) {
                    let itsItemData = item.itsItemData || {}
                    let address = {
                        name: itsItemData.hospitalName,
                        latitude: itsItemData.gps.latitude,
                        longitude: itsItemData.gps.longitude,
                        city: this.event.cityDictVal
                    }
                    // 其他类型餐厅
                    this["ADDRESS"](address)
                } else {
                    if(this.currentPosition.city && this.currentPosition.city == this.event.cityDictVal) {
                        this["ADDRESS"](this.currentPosition)
                    } else {
                        this["ADDRESS"](this.cityAddress)
                    }
                }
                this["FRESH_SHOP"](true)

                let optionalType = await this.getWaimaiType()
                if(optionalType){
                    this.openShopArr(item)
                    return
                }
                this.$router.push('/shopList?refresh=true')
        },
        async openShopArr(item){
			let mealCombineData = [];
			const sessionIdData = await this.saveCacheData()
            let shopUrl = SmartStorage.get('Uris').Uris['webapp-imeal'] + '/shopList?refresh=true&type=selectShop&sessionId=' +  sessionIdData
            mealCombineData.push({
				selected: 'https://spkg.smartmice.cn/resources/images/imeal/jh_ele_gd_xms_focus.png',
				normal: 'https://spkg.smartmice.cn/resources/images/imeal/jh_ele_gd_xms_blur.png',
				url: shopUrl
			})
			//获取美团地址`
            let meituanUrl = ''
			this.ItemId = item.itemId;
			let meituanParams ={
				ItemId: item.itemId,
				longitude: this.address.longitude,
				latitude: this.address.latitude,
			}
			const meituanRes = await this.MeituanLogin(meituanParams)
			if (meituanRes) {
				meituanUrl = meituanRes;
			}else{
				return
			}
			mealCombineData.push({
				selected: 'https://spkg.smartmice.cn/resources/images/imeal/wm_mt_focus.png',
				normal: 'https://spkg.smartmice.cn/resources/images/imeal/wm_mt_blur.png',
				url: meituanUrl
			})
            let _this = this;
            const options = {
                method: "SMGeneral.openNewWebSiteForResult",
                postData:{
                    loadUrl: 'mealCombineData',
                    cookieData: getAllCookies(),
                    mealCombineData: mealCombineData,
                },
                callback: (viewData) => {
                    if(!viewData || viewData =='' || viewData == {} || viewData == "{}"){
                        setTimeout(() =>{
                            _this.dochangeShop({fromIshop: false})
                        },800)
                        return
                    }
                    let postData = JSON.parse(viewData)
                    _this.dochangeShop(postData)
                }
            };
            this.iJsBridge.call(options);
        },
        MeituanLogin(meituanParams){
            return new Promise((resolve,reject) => {
                miceService.meituanLogin(meituanParams).then(res => {
                    if(res && res.success){
                        resolve(res.content)
                    }
                }).catch(err => {
                    reject(err)
                })
            }) 
        },
        // 获取外出用餐类型
        getWaimaiType() {
            let params = {
                collection: "cfg-imeal-channel",
                useCaching: false,
                cachingKey: "",
                filter: {
                    tenantCode: this.event.tenant_code || "crossevent",
                    mealType: "外出用餐"
                },
                projection: {
                    optionalType: 1,
                }
            };
            return new Promise((resolve, reject) => {   
                miceService.getOptItems(params).then(res => {
                    if (res && res.success && res.content) {
                        resolve((res.content[0] || {optionalType:[]}).optionalType.includes('美团'))
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        saveCacheData(){
			// 数据持久化保存数据
			let eventDataParams = {
                Data: {
                    eventData: this.event || {},
                    token: getCookie('token'),
                    proposalId: this.event.proposalId,
                    tenant_id: getCookie('tenant_id'),
                    tenant_code: SmartStorage.get('tenant_code') || this.event.tenant_code,
                    tenant: SmartStorage.get('tenant_code') || this.event.tenant_code,
                    noBack: true,
                    paramCode: SmartStorage.get("paramCode")
                }
            }
            return new Promise((resolve,reject) => {
                miceService.saveCacheData(eventDataParams).then(sessionRes => {
                    if(sessionRes && sessionRes.success){
                        resolve(sessionRes.content)
                    }
                }).catch(err => {
                    reject(err)
                })
            }) 
        },
        selectSYT(item) {
            let time = item.dtStart
            time = time.replace(/T/g, " ")
            time = time.replace(/-/g, "/") 
            let date = new Date(time).getTime();
            let params = {
                orderType: item.itemName,
                reservationTime: date,
                predictCost: item.amount,
                a1OrderId: item.itemId,
                city: this.event.cityDictVal,
                jobnum: this.memsg.userId,
                name: this.memsg.dspName,
                phone: this.memsg.phoneNumber,
                dinerName: item.itsItemData.bookingName,
                dinerPhone: item.itsItemData.bookingPhoneNum,
                peopleNum: item.qty1 || 0,
            }
            let _this = this
            this.openMealSYT(params, () => {
                setTimeout(() => {
                    _this['FRESH_LIST'](true)
                }, 2000)
                // 更新列表
            })

        },
        // 功能还为写完
        // selectShop() {
        //     var _this = this;
        //     let eventData = {
        //         ...this.event,
        //         city: this.event.cityDictVal, //用餐城市
        //     }
        //     this.$cookies.setCookie("eventData", JSON.stringify(eventData), {
        //         domain: window.idomain
        //     });
        //     const tenantcode = _this.event.tenant_code;
        //     const options = {
        //         loadUrl: `${baseUrl.iShopUrl}/index?tenantcode=${tenantcode}&changeshop=true`,
        //         callback: function (viewData) {
        //             const data = JSON.parse(viewData)
        //             _this.dochangeShop(data)
        //         }
        //     }
        //     this.iJsBridge.openWebapp(options)
        // },
        async dochangeShop(data) {
            var orderDetail = this.orderDetail || {
                itsItemData: {}
            }
            var params = {
                itemId: orderDetail.itemId,
                bookingName: orderDetail.itsItemData.bookingName,
                bookingPhoneNum: orderDetail.itsItemData.bookingPhoneNum,
                oldShopRowId: orderDetail.itsItemData.shopId
            }
            let shopDetail = data || this.shop
            params.shopRowId = shopDetail.rowId;
            if(shopDetail.fromIshop){
                let shopParams = {
                    itemId: orderDetail.itemId,
                    ShopRowId: shopDetail.shopRowId,
                    bookingName: orderDetail.itsItemData.bookingName,
                    bookingPhoneNum: orderDetail.itsItemData.bookingPhoneNum,
                    SourceCode: shopDetail.sourceCode,
                    ShopName: shopDetail.fullName,
                    ShopImg: shopDetail.imgThumbnail,
                    ShopMobile: shopDetail.tel,
                    ShopAdress: shopDetail.address,
                    gps: {
                        nl: shopDetail.nl || '',
                        el: shopDetail.el || ''
                    }
                }
                params.sourceCode = shopDetail.sourceCode
                await this.SaveChangeShop(shopParams)
            }else{
                params.sourceCode = "ELE"
            }
            params.isExtra = true
            miceService.changeShop(params).then(res => {
                if (res && res.success) {
                    // this.toast('餐厅更换成功')
                    this.$refs.chang.openPop();
                    this['SHOP']({})
                    this['FRESH_LIST'](true)
                }
            })
        },
        SaveChangeShop(eventDataParams){
            return new Promise((resolve,reject) => {
                miceService.SaveChangeShop(eventDataParams).then(sessionRes => {
                    if(sessionRes && sessionRes.success){
                        resolve(sessionRes)
                    }
                }).catch(err => {
                    reject(err)
                })
            }) 
        },
        //小秘书  
        setXmsPayResultValue(item) {
            this['XMS_PAY_RESULT']({})
            var itsItemData = item.itsItemData;
            var platform = itsItemData.platform;
            if (platform != 1) return;
            var status = item.status;
            var content = (itsItemData || { payResultInfo: {}, shopImg: '', shopName: '', })
            var payResultInfo = content.payResultInfo;
            var isCheckedPay = itsItemData.isCheckedPay;
            var showXiaoMiShuPayResult = false;
            if (status >= 4 && isCheckedPay === false) {
                showXiaoMiShuPayResult = true;
            }
            payResultInfo = {
                money: (payResultInfo || { money: '' }).money,
                payCheckCodeUrl: (payResultInfo || { payCheckCodeUrl: '' }).payCheckCodeUrl,
                payCode: (payResultInfo || { payCode: '' }).payCode
            }
            var shopInfo = {
                shopImg: content.shopImg,
                shopName: content.shopName
            }
            var xmsPayResult = {
                isNeedUploadInvoice: false, //查看详情进入小秘书支付结果不显示上传发票按钮
                payResultInfo: payResultInfo,
                shopInfo: shopInfo,
                showXiaoMiShuPayResult: showXiaoMiShuPayResult
            }
            this['XMS_PAY_RESULT'](xmsPayResult)
        }
    },

    filters: {
        qty1: value => {
            if (value && value >= 0) {
                return value + "人";
            } else {
                return "0人";
            }
        },
        amount: value => {
            if (value && value >= 0) {
                return parseFloat(value).toFixed(2);
            } else {
                return 0;
            }
        },
        dateTime: (value) => {
            if (value) {
                return value.substring(0, 10) + ' ' + value.substring(11, 16)
            }
        },
    }
};